import defineMessages from "../../../../../common/helpers/defineMessages";

const messages = defineMessages({
    isSolfa: {
        id: "meta.isSolfa",
    },
    clef: {
        id: "meta.clef",
    },
    key: {
        id: "meta.key",
    },
    solfaNames: {
        id: "meta.solfaNames",
    },
    scale: {
        id: "meta.scale",
    },
    intervals: {
        id: "meta.intervals",
    },
    range: {
        id: "meta.range",
    },
    noData: {
        id: "general.noData",
    },
});

export default messages;
